import React from 'react';
import styles from './Header.module.css';
import { Typography } from '@strapi/design-system/Typography';
import { Back } from '#shared/components/Back';
import Breadcrumb from '#shared/components/Breadcrumb';

export const Header = ({
  titleRender,
  title,
  subtitle,
  subtitleClassName = '',
  actions,
  backTo,
  noBack = false,
  className = '',
  hasBreadcrumb = false,
}) => {
  return (
    <div className={[styles.main, className].join(' ')}>
      <div className={styles['headers-box']}>
        {!noBack && <Back customGoBack={backTo} />}
        {hasBreadcrumb && <Breadcrumb title={title} />}

        {titleRender
        ? titleRender
        : (
          <Typography
            variant="alpha"
            as="h1"
            className={hasBreadcrumb ? styles.title : ''}
          >
            {title}
          </Typography>
        )}
        <Typography
          className={[styles.subtitle, subtitleClassName].join(' ')}
          variant="epsilon"
          fontWeight="bold"
        >
          {subtitle}
        </Typography>
      </div>
      {actions}
    </div>
  );
};
